import { Controller } from "@hotwired/stimulus"
import { Html5Qrcode } from "html5-qrcode"

export default class extends Controller {
  static targets = ["input", "viewport", "button", "stopButton"]

  connect() {
    this.scanner = null
    this.scanning = false
  }

  disconnect() {
    this.stop()
  }

  async start() {
    if (this.scanning) return

    this.viewportTarget.classList.remove("d-none")
    this.buttonTarget.classList.add("d-none")
    this.stopButtonTarget.classList.remove("d-none")

    this.scanner = new Html5Qrcode(this.viewportTarget.id)

    try {
      await this.scanner.start(
        { facingMode: "environment" },
        { fps: 10, qrbox: { width: 250, height: 150 } },
        (decodedText) => {
          this.inputTarget.value = decodedText.trim().toUpperCase()
          this.stop()
        }
      )
      this.scanning = true
    } catch (err) {
      console.error("Camera error:", err)
      this.reset()
      alert("Impossibile accedere alla fotocamera. Verifica i permessi.")
    }
  }

  async stop() {
    if (this.scanner && this.scanning) {
      try {
        await this.scanner.stop()
        this.scanner.clear()
      } catch (_) {}
    }
    this.reset()
  }

  reset() {
    this.scanning = false
    this.scanner = null
    this.viewportTarget.classList.add("d-none")
    this.buttonTarget.classList.remove("d-none")
    this.stopButtonTarget.classList.add("d-none")
  }
}
